/* global window */
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { logEvent } from 'common/helpers/analytics';
import { isPreSale, isDarioush } from 'common/helpers/featureFlags';
import { updateAndProcessClubSignup } from 'redux/clubSignup/actions';

class Process extends Component {
  handleProcess = (e) => {
    e.preventDefault();
    const { props } = this;
    const clubSignup = {
      clubId: props.club.id
    };
    const successFunction = (membership) => {
      logEvent('ClubSignup', 'V1 Complete');
      if (isDarioush()) {
        window.location.href = `/membership/welcome/${membership.id}`;
      } else {
        props.history.push(`/club/receipt/${membership.id}`);
      }
    };
    props.updateAndProcessClubSignup(clubSignup, successFunction);
  };

  render() {
    let clubSignup = 'Club';
    if (isPreSale()) {
      clubSignup = 'Pre-Sale';
    }
    return (
      <div className="c7-checkout__content__buttons">
        <button
          type="button"
          className="c7-button"
          onClick={this.handleProcess}
        >
          Complete {clubSignup} Sign Up
        </button>
      </div>
    );
  }
}

export default withRouter(
  connect(null, { updateAndProcessClubSignup })(Process)
);
